module.exports = __webpack_public_path__ + "img/car_13.efd8f8b0.jpg";